<template>
  <div class="profile-settings-notifications">
    <div class="profile--settings--row row">
      <div class="columns">
        <h5 class="notification-title">
          {{
            $t('PROFILE_SETTINGS.FORM.PUSH_NOTIFICATIONS_SECTION.TIMEOUT.TITLE')
          }}
        </h5>
        <div class="notification-timeout-options">
          <woot-switch v-model="is_persistent" @input="updatePreferences" />
          <p>
            {{
              $t(
                'PROFILE_SETTINGS.FORM.PUSH_NOTIFICATIONS_SECTION.TIMEOUT.OPTION'
              )
            }}
            <span
              v-tooltip.top="
                $t(
                  'PROFILE_SETTINGS.FORM.PUSH_NOTIFICATIONS_SECTION.TIMEOUT.NOTE'
                )
              "
              class="info-icon"
            >
              ⓘ
            </span>
          </p>
        </div>
        <div v-if="is_persistent" class="info-container">
          <img
            src="~/dashboard/assets/icons/warning-icon.svg"
            alt="warning message"
            loading="lazy"
          />
          <p class="info-container__text">
            {{
              $t(
                'PROFILE_SETTINGS.FORM.PUSH_NOTIFICATIONS_SECTION.TIMEOUT.WARNING_MESSAGE'
              )
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      is_persistent: false,
    };
  },
  computed: {
    ...mapGetters({
      pushSettings: 'userNotificationSettings/getPushSettings',
    }),
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    loadSettings() {
      if (this.pushSettings) {
        this.is_persistent = this.pushSettings.is_persistent;
      }
    },
    updatePreferences() {
      this.$emit('onChangeTimeout', {
        is_persistent: this.is_persistent,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.columns {
  min-width: 456px;
}
.notification-timeout-options {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}
.notification-title {
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-one);
  font-size: var(--font-size-small);
}

.info-icon {
  font-size: 13px;
  color: var(--s-700);
  cursor: pointer;
  padding-left: 5px;
}
.info-container {
  display: flex;
  align-items: start;
  gap: 4px;
  padding: 8px;
  border-radius: 12px;
  background: var(--color-oringe);
  &__text {
    white-space: nowrap;
    font-size: var(--font-size-normal) !important;
    color: var(--h-700);
    margin-bottom: 0 !important;
  }
}
</style>
